import styled from '@emotion/styled'
import { BREAKPOINTS } from 'utils/styled'

export const SWrapper = styled.div`
  position: relative;
  line-height: 0;
`

export const SActionsWrapper = styled.div`
  position: absolute;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  z-index: 100;

  &.default {
    top: 1rem;
    left: 1rem;
  }

  @media ${BREAKPOINTS.MD.max} {
    &.default {
      top: 0.5rem;
      left: 0.5rem;
      justify-content: center;
    }
  }

  &.top-right {
    top: 1rem;
    right: 1rem;
  }

  @media ${BREAKPOINTS.MD.max} {
    &.top-right {
      top: 0.5rem;
      right: 0.5rem;
    }
  }

  //prevents this wrapper to block pointer events on the video
  pointer-events: none;

  & > * {
    //makes sure child actions are still clickable
    pointer-events: all;
  }
`
